import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_DISPOSAL,
  DELETE_DISPOSAL,
  UPDATE_DISPOSAL,
  ADD_NEW_DISPOSAL,
} from "./actionType";

import {
  getDisposalSuccess,
  getDisposalFail,
  deleteDisposalSuccess,
  deleteDisposalFail,
  updateDisposalSuccess,
  updateDisposalFail,
  addDisposalSuccess,
  addDisposalFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveDisposalApi,
  getDisposalApi,
  updateDisposalApi,
  deleteDisposalApi,
  addNewDisposalApi
} from "../../helpers/backend_helper";

function* getDisposal({ payload: disposal }) {
  try {
    const response = yield call(getDisposalApi, disposal);
    yield put(getDisposalSuccess(GET_DISPOSAL, response.data));
  } catch (error) {
    yield put(getDisposalFail(GET_DISPOSAL, error));
  }
}

function* onUpdateDisposal({ payload: disposal }) {
  try {
    if (disposal.setApprove) {
      const response = yield call(approveDisposalApi, disposal);
      yield put(updateDisposalSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateDisposalApi, disposal);
      yield put(updateDisposalSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateDisposalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteDisposal({ payload: disposal }) {
  try {
    const response = yield call(deleteDisposalApi, disposal);
    yield put(deleteDisposalSuccess({ disposal, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteDisposalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewDisposal({ payload: disposal }) {
  try {
    const response = yield call(addNewDisposalApi, disposal);
    yield put(addDisposalSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addDisposalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetDisposal() {
  yield takeEvery(GET_DISPOSAL, getDisposal);
}

export function* watchUpdateDisposal() {
  yield takeEvery(UPDATE_DISPOSAL, onUpdateDisposal);
}

export function* watchDeleteDisposal() {
  yield takeEvery(DELETE_DISPOSAL, onDeleteDisposal);
}

export function* watchAddNewDisposal() {
  yield takeEvery(ADD_NEW_DISPOSAL, onAddNewDisposal);
}

function* disposalSaga() {
  yield all([
    fork(watchGetDisposal),
    fork(watchDeleteDisposal),
    fork(watchUpdateDisposal),
    fork(watchAddNewDisposal),
  ]);
}

export default disposalSaga;
